module.exports = __webpack_public_path__ + "static/media/portfolio.af3a1ae8.png";